document.addEventListener('DOMContentLoaded', function() {

    const load_btn = document.querySelector(".custom-filter-load-more");
    const infinite_scroll = document.querySelector('.infinite-scroll');
    let products_on_page = document.querySelector('.collection-grid');
    let url = products_on_page.getAttribute('data-next-url');
    const spinner = document.querySelector('.load-more-spinner');

    const load_more = () => {
        spinner.classList.add("show");

        fetch(url)
            .then(function (response) {
                if (response.ok) {
                    return response.text();
                } else {
                    throw new Error('Network response was not ok.');
                }
            })
            .then(function (data) {
                const html = document.createElement('div');
                html.innerHTML = data;

                let links = html.querySelector('.pagination-links').innerHTML;
                document.querySelector('.pagination-links').innerHTML = links;

                let new_grid = html.querySelector('.collection-grid');
                url = new_grid.getAttribute('data-next-url');
                if (url === '') {
                    load_btn.style.display = 'none';
                }
                let new_products = new_grid.querySelectorAll(".product-card, .collection-grid-cta, .tp-builder-product-card");

                new_products.forEach(new_prod => {
                    products_on_page.append(new_prod);
                });
                spinner.classList.remove("show");

                window.yotpoWidgetsContainer.initWidgets()
                var api = new Yotpo.API(yotpo);
                api.refreshWidgets();
            })
            .catch(function (error) {
                window.log(error);
            });
    }

    if (load_btn) {
        if (url === '') {
            load_btn.style.display = 'none';
        }

        load_btn.addEventListener("click", ()=> {
            load_more();
        });

        if (infinite_scroll) {
            // Intersection Observer
            const options = {
                root: null,
                rootMargin: '300px',
                threshold: 0.1
            }

            const observer = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        load_more();
                    }
                });
            }, options);

            observer.observe(infinite_scroll);
        }


    }

    const rangeInput = document.querySelectorAll(".range-input input");
    if (rangeInput) {
        const priceInput = document.querySelectorAll(".price-input-show");
        const range = document.querySelector(".slider .progress");
        const minFilterInput = document.querySelector('.min-price-filter');
        const maxFilterInput = document.querySelector('.max-price-filter');
        let priceGap = 1;

        if (maxFilterInput && minFilterInput) {

            if (maxFilterInput.value != "") {
                range.style.left = ((minFilterInput.value / rangeInput[0].max) * 100) + "%";
                range.style.right = 100 - (maxFilterInput.value / rangeInput[1].max) * 100 + "%";
                rangeInput[0].value = minFilterInput.value;
                rangeInput[1].value = maxFilterInput.value;
                priceInput[0].innerHTML = minFilterInput.value;
                priceInput[1].innerHTML = maxFilterInput.value;
            }

            priceInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minPrice = parseInt(priceInput[0].innerHTML);
                    let maxPrice = parseInt(priceInput[1].innerHTML);

                    if ((maxPrice - minPrice >= priceGap) && maxPrice <= rangeInput[1].max) {
                        if (e.target.className === "input-min") {
                            rangeInput[0].value = minPrice;
                            rangeInput[0].setAttribute("data-term", minPrice);
                            range.style.left = ((minPrice / rangeInput[0].max) * 100) + "%";
                        } else {
                            rangeInput[1].value = maxPrice;
                            maxFilterInput.value = maxVal;
                            range.style.right = 100 - (maxPrice / rangeInput[1].max) * 100 + "%";
                        }
                    }
                });
            });

            rangeInput.forEach(input => {
                input.addEventListener("input", e => {
                    let minVal = parseInt(rangeInput[0].value),
                    maxVal = parseInt(rangeInput[1].value);

                    if ((maxVal - minVal) < priceGap) {
                        if (e.target.className === "range-min") {
                            rangeInput[0].value = maxVal - priceGap
                        } else {
                            rangeInput[1].value = minVal + priceGap;
                        }
                    } else {
                        priceInput[0].innerHTML = minVal;
                        priceInput[1].innerHTML = maxVal;
                        range.style.left = ((minVal / rangeInput[0].max) * 100) + "%";
                        range.style.right = 100 - (maxVal / rangeInput[1].max) * 100 + "%";
                        minFilterInput.value = minVal;
                        maxFilterInput.value = maxVal;
                    }
                });
            });
        }
    }

    let custom_filters = document.querySelectorAll(".custom-filter")

    custom_filters.forEach((el)=>{

        let control = el.querySelector(".filter-heading")
        let body = el.querySelector(".filter-body")

        if(control && body){
            control.addEventListener('click', (e) => {
                e.stopPropagation();
                
                const isOpen = el.classList.contains("open");
                
                // Close all filters first
                custom_filters.forEach((filter)=>{
                    filter.classList.remove("open")
                })
                
                // Toggle the clicked filter
                if(!isOpen){
                    el.classList.add("open");
                }
            })
        }
    })

    document.body.addEventListener('click', (e) => {
        if(!e.target.closest(".custom-filter")){
            custom_filters.forEach((el)=>{
                el.classList.remove("open")
            })
        }
    });

    let mobile_control = document.querySelector(".mobile-filter-heading")
    let filter_body = document.querySelector(".custom-filter-wrapper")

    if(mobile_control && filter_body){
        mobile_control.addEventListener('click', () => {
            // rotate svg
            if(mobile_control.classList.contains("open")){
                mobile_control.classList.remove("open")
            } else {
                mobile_control.classList.add("open")
            }

            // open filters
            if(filter_body.classList.contains("open")){
                filter_body.classList.remove("open")
            } else {
                filter_body.classList.add("open")
            }
        })
    }

    // Active Tots branding: desktop "Filters" open/close toggle. Opens
    // inline on the left, in the same spot as the usual TP Toys sidebar
    // (see tp-collection-grid.scss .style-active-tots #qf-filter-wrapper).
    // Only present when the Collection Grid section's "Enable Tots theme"
    // setting is on. No-op everywhere else.
    // Opening/closing is controlled ONLY by clicking this toggle — no
    // outside-click, Escape key, or separate close button.
    const totsFiltersToggle = document.getElementById('TotsFiltersToggle');
    const totsFilterPanel = document.getElementById('TotsFilterPanel');

    if (totsFiltersToggle && totsFilterPanel) {
        const openTotsPanel = () => {
            totsFilterPanel.classList.add('tots-panel-open');
            totsFiltersToggle.classList.add('is-open');
            totsFiltersToggle.setAttribute('aria-expanded', 'true');
        };

        const closeTotsPanel = () => {
            totsFilterPanel.classList.remove('tots-panel-open');
            totsFiltersToggle.classList.remove('is-open');
            totsFiltersToggle.setAttribute('aria-expanded', 'false');
        };

        totsFiltersToggle.addEventListener('click', (e) => {
            e.stopPropagation();
            if (totsFilterPanel.classList.contains('tots-panel-open')) {
                closeTotsPanel();
            } else {
                openTotsPanel();
            }
        });
    }

    // Tots has two Sort by controls (desktop toolbar radios + mobile
    // drawer select). Disable the one that isn't on screen so the form
    // only submits a single sort_by value.
    const totsMobileSortSelect = document.querySelector('.tots-mobile-sort select');
    const totsToolbarSortInputs = document.querySelectorAll('.tots-filter-toolbar [name="sort_by"]');

    if (totsMobileSortSelect || totsToolbarSortInputs.length) {
        const totsSortMedia = window.matchMedia('(max-width: 767.98px)');
        const syncTotsSortFields = () => {
            const isMobile = totsSortMedia.matches;
            if (totsMobileSortSelect) {
                totsMobileSortSelect.disabled = !isMobile;
            }
            totsToolbarSortInputs.forEach((input) => {
                input.disabled = isMobile;
            });
        };

        syncTotsSortFields();
        if (totsSortMedia.addEventListener) {
            totsSortMedia.addEventListener('change', syncTotsSortFields);
        } else {
            totsSortMedia.addListener(syncTotsSortFields);
        }
    }

    // const reset_filters = document.querySelector('.reset-filter-wrapper');
    const selected_filters_html = document.querySelectorAll('.selected-filter-wrapper *');

    selected_filters_html.forEach(selected => {
        selected.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    })

    // Submit form on input change

    // Active Tots: the toolbar (with its Sort by dropdown) renders in its
    // own row above #qf-filter-wrapper, outside .filter-container-wrapper —
    // its inputs are associated back to the form via form="TotsFilterForm",
    // so they need including here explicitly too.
    const filter_inputs = document.querySelectorAll('.filter-container-wrapper select, .filter-container-wrapper input, .tots-filter-toolbar select, .tots-filter-toolbar input');
    const filter_form = document.querySelector('.filter-container');
    const reset_filter = document.querySelector('#reset-filters');
    const collection_grid = document.querySelector('.collection-grid');

    filter_inputs.forEach(input => {
        input.addEventListener('change', () => {
            collection_grid.classList.add("loading")
            filter_form.submit()
        })
    })

    if (reset_filter) {
        reset_filter.addEventListener('click', () => {
            collection_grid.classList.add("loading")
        })
    }
})